import * as Y from "yjs";
import { WebsocketProvider } from "y-websocket";
import { useEffect, useRef } from "react";

export default function useCollabImageSrc(projectId, onRemote) {
  const ydocRef = useRef(null);
  const providerRef = useRef(null);
  const yMapRef = useRef(null);

  const cbRef = useRef(onRemote);
  useEffect(() => {
    cbRef.current = onRemote;
  }, [onRemote]);

  useEffect(() => {
    if (!projectId) return;

    const ydoc = new Y.Doc();
    const provider = new WebsocketProvider(
      process.env.REACT_APP_SOCKET_URL || "ws://localhost:1234",
      String(projectId),
      ydoc
    );

    const yMap = ydoc.getMap("image"); // isolated from "rotation"

    const observer = () => {
      const src = yMap.get("src");
      if (typeof src === "string" && src.length) cbRef.current?.(src);
    };

    yMap.observe(observer);
    observer(); // hydrate late joiners

    ydocRef.current = ydoc;
    providerRef.current = provider;
    yMapRef.current = yMap;

    return () => {
      try {
        yMap.unobserve(observer);
      } catch {}
      try {
        provider.destroy();
      } catch {}
      try {
        ydoc.destroy();
      } catch {}
      ydocRef.current = null;
      providerRef.current = null;
      yMapRef.current = null;
    };
  }, [projectId]);

  const syncImageSrc = (dataUrl) => {
    if (!yMapRef.current) return;
    if (typeof dataUrl !== "string" || !dataUrl) return;
    yMapRef.current.set("src", dataUrl);
  };

  return { syncImageSrc };
}
